import React from "react";

const HackenBadge: React.FC = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
      <a
        href="https://hacken.io/audits/astra-nova/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://wp.hacken.io/wp-content/uploads/2024/12/audited-by-hacken-color_light.svg"
          alt="Audited by Hacken"
          style={{ width: "122px", height: "45px" }} // Reduced by 30%
        />
      </a>
    </div>
  );
};

export default HackenBadge;
